<template>
  <div>
    <div style="display: flex; justify-content: flex-end;">
      <Button
        v-if="canpremAdd"
        type="primary"
        @click="create"
      >
        新增权限
      </Button>
    </div>

    <Card style="margin-top: 30px">
      <Tree
        v-if="canpremList"
        class="tree"
        :data="data"
        :props="defaultProps"
        node-key="id"
      >
        <span
          slot-scope="{ node, data }"
          class="tree-node"
        >
          <span>{{ node.label }}</span>
          <span>
            <el-button
              v-if="canpremAdd"
              style="margin-left: 15px"
              type="text"
              size="mini"
              @click="() => append(data)"
            >
              新增
            </el-button>
            <el-button
              v-if="canpremEdit"
              type="text"
              size="mini"
              @click="() => update(data)"
            >
              修改
            </el-button>
            <el-button
              v-if="canpremDelete"
              type="text"
              size="mini"
              @click="() => remove(node, data)"
            >
              删除
            </el-button>
            <el-button
              v-if="node.childNodes.length === 0 && cansetRouter"
              type="text"
              size="mini"
              @click="() => getRouters(data)"
            >
              设置路由
            </el-button>
          </span>
        </span>
      </Tree>
    </Card>

    <Editor
      :visible.sync="visible"
      :dataSource="current"
      :type="type"
      @confirm="handleConfirm"
    />

    <Router
      :visible.sync="routerVisible"
      :dataSource="routers"
      @create="handleRouterCreate"
      @remove="handleRouterRemove"
    />
  </div>
</template>

<script>
import { Tree, Button, Card } from 'element-ui';

import Editor from './components/Editor';
import Router from './components/Router';

import requestMixin from './mixins/request';

export default {
  components: {
    Tree,
    Button,
    Card,

    Editor,
    Router,
  },

  mixins: [requestMixin],

  data() {
    return {
      data: [],
      defaultProps: {
        label: 'name',
      },
      current: null,
      visible: false,
      routerVisible: false,
      type: 'add',
      routers: {},
    };
  },

  computed: {
    perms() {
      return this.$store.state.perms;
    },

    canpremList() {
      return this.perms.includes('premList');
    },

    canpremAdd() {
      return this.perms.includes('premAdd');
    },

    canpremEdit() {
      return this.perms.includes('premEdit');
    },

    canpremDelete() {
      return this.perms.includes('premDelete');
    },

    cansetRouter() {
      return this.perms.includes('setRouter');
    },
  },

  created() {
    this.getPermList();
  },

  methods: {
    create() {
      this.type = 'add';
      this.visible = true;
    },

    append(data) {
      this.current = data;
      this.type = 'add';
      this.visible = true;
    },

    update(data) {
      this.current = data;
      this.type = 'update';
      this.visible = true;
    },

    remove(node, data) {
      this.$confirm('你确定要删除当前权限吗？').then(() => {
        const params = { id: data.id };
        this.removePerm(params, node);
      });
    },

    async getRouters(data) {
      const params = { perm_id: data.id };
      const res = await this.getPermRouters(params);
      if (res) {
        this.routerVisible = true;
        this.routers = { data: res, id: data.id };
      }
    },

    handleConfirm(data) {
      if (this.type === 'add') {
        this.addPerm(data);
      } else if (this.type === 'update') {
        this.updatePerm(data);
      }
    },

    handleRouterCreate(data) {
      this.addPermRouter(data);
    },

    handleRouterRemove(data) {
      this.removePermRouter(data);
    },
  },
};
</script>

<style lang="less" scoped>
.tree {
  &-node {
    display: flex;
    align-items: center;
  }

  &-operation {
    margin-left: 20px;
  }
}
</style>